module.exports = __webpack_public_path__ + "media/customizations/blackwoodgroves/back-a1f13d63198e10610142bd953767d7e9.jpg";